/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'device-sm': {
    width: 16,
    height: 16,
    viewBox: '0 4 24 16',
    data: '<path pid="0" d="M19 18H5V6h14m2-2H3c-1.11 0-2 .89-2 2v12a2 2 0 002 2h18a2 2 0 002-2V6a2 2 0 00-2-2z"/>'
  }
})
